export const PAYMENT_STATUS_NEW = process.env.REACT_APP_PAYMENT_STATUS_NEW
export const PAYMENT_STATUS_COMPLETED = process.env.REACT_APP_PAYMENT_STATUS_COMPLETED
export const PAYMENT_STATUS_FAILED = process.env.REACT_APP_PAYMENT_STATUS_FAILED
